module.exports = __webpack_public_path__ + "img/google-play-badge.0dd8498b.png";